export function farloUiMasthead(element) {
    const carouselElement = document.querySelector('.revolver-carousel');
    if (carouselElement) {
        // Step 1: Clean Up Pre-existing Flickity Classes
        carouselElement.classList.remove('flickity-enabled', 'is-draggable');

        // Step 2: Remove 'is-selected' from all cells
        const cells = carouselElement.querySelectorAll('.flickity-cell');
        cells.forEach(cell => cell.classList.remove('is-selected'));


        // Step 4: Initialize Flickity after Images Load
        imagesLoaded(carouselElement, () => {
            handleResize();
        });

        // Step 5: Handle Window Resize with Debounce
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                handleResize();
            }, 150);
        });

        // Function to Initialize Flickity
        function initializeFlickity() {



            flkty = new Flickity(carouselElement, {
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: false,
                //autoPlay: false,
                autoPlay: 2500,
                pauseAutoPlayOnHover: true,
                wrapAround: false,
                fade: true,
                groupCells: false,
                freeScroll: true,
                draggable: true,
                cellSelector: '.site-masthead__image-media',
                scrollSnap: true,
                adaptiveHeight: false, // Adjust height based on selected cell
            });


            // Listen to Flickity events for debugging
            flkty.on('ready', () => {
                flkty.resize();
            });

            // flkty.on('select', (index) => {
            //     console.log('Selected slide:', index);
            // });

            // flkty.on('resize', () => {
            //     console.log('Flickity resize event fired.');
            // });

            // Force Flickity to recalculate layout after a short delay
            setTimeout(() => {
                flkty.resize();
            }, 100); // Adjust the delay as necessary



        }

        // Function to Handle Resize and Initialize/Destroy Flickity Accordingly
        function handleResize() {

            initializeFlickity();
        }


    }
}
